import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'Depths',
    name: 'La Mégère',
    id: 'HordeCrone',
    health: 60,
    difficulty: 6,
    additionalInfo: '',
    expeditionRating: 2,
  },
]
